<template>
  <div class="container">
    <BasicTitle title="Nuevo Reporte" />
    <BasicSubtitle subtitle="Los campos señalados con (*) son obligatorios." />
    <div class="container-form">
      <BasicLabel label="Título *" />
      <BorderInput v-model="report.data.title" label="Título *" />
      <FormError :show="report.rules.title" message="Ingrese un título" />

      <BasicLabel label="Descripción *" />
      <BorderInput v-model="report.data.description" label="Descripción *" />
      <FormError
        :show="report.rules.description"
        message="Ingrese una descripción"
      />

      <BasicLabel label="Fecha de Registro *" />
      <BorderDate v-model="report.data.date" label="Fecha de Registro *" />
      <FormError :show="report.rules.date" message="Seleccione una fecha" />

      <BorderFile :v-model="report.selectedDocuments" @select="onSelectFiles" />
      <FormError />
    </div>
    <PrimaryButton label="Guardar" :click="onSave" />
  </div>
</template>

<script>
import BasicTitle from "../../widgets/title/BasicTitle";
import BasicLabel from "../../widgets/label/BasicLabel";
import BasicSubtitle from "../../widgets/subtitle/BasicSubtitle";
import BorderInput from "../../widgets/input/BorderInput";
import BorderSelect from "../../widgets/select/BorderSelect";
import BorderInputPrefix from "../../widgets/input/BorderInputPrefix";
import BorderInputPhone from "../../widgets/input/BorderInputPhone";
import FormError from "../../widgets/error/FormError";
import PrimaryButton from "../../widgets/button/PrimaryButton";
import BorderDate from "../../widgets/calendar/BorderDate.vue";
import BorderTime from "../../widgets/calendar/BorderTime.vue";
import OutlinedTextArea from "../../widgets/textarea/OutlinedTextArea.vue";
import store from "../../store";
import { onBeforeMount, onBeforeUnmount, reactive, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import { openMode } from "../../constants";
import { validation, actions, aws } from "../../constants";
import BorderFile from "../../widgets/file/BorderFile.vue";

export default {
  components: {
    BasicTitle,
    BasicLabel,
    BasicSubtitle,
    BorderInput,
    BorderSelect,
    BorderInputPrefix,
    BorderInputPhone,
    BorderDate,
    BorderTime,
    FormError,
    PrimaryButton,
    BorderFile,
    OutlinedTextArea,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const report = reactive({
      selectedDocuments: [],
      data: {
        id: -1,
        title: "",
        description: "",
        date: new Date(),
      },
      rules: {
        title: false,
        description: false,
        date: false,
      },
    });

    const onSelectFiles = (ev) => {
      report.selectedDocuments = ev.files;
    };

    const validate = () => {
      let valid = true;

      if (!report.data.title) {
        report.rules.title = true;
        valid = false;
      }
      if (!report.data.description) {
        report.rules.description = true;
        valid = false;
      }
      if (!report.data.date) {
        report.rules.date = true;
        valid = false;
      }

      return valid;
    };

    const onSave = async () => {
      if (!validate()) return;

      store.commit("setLoading", true);

      const responsePath = await store.dispatch(
        actions.documentActions.getPath,
        {
          buildingId: store.state.general.selectedBuilding,
          folderName: report.data.title,
          documentTypeName: "Reportes",
        }
      );

      if (responsePath.ok) {
        let count = 0;
        const documents = [];
        const { length } = report.selectedDocuments;
        const finish = async () => {
          const request = {
            buildingId: store.state.general.selectedBuilding,
            userId: store.state.auth.user.id,
            title: report.data.title,
            description: report.data.description,
            date: report.data.date,
          };

          if (documents.length) {
            request.path = documents[0].path;
            request.name = documents[0].name;
            request.ext = documents[0].ext;
          }

          const response = await store.dispatch(
            actions.reportActions.create,
            request
          );
          store.commit("setLoading", false);
          if (response.ok) {
            store.commit("setSelectedReports", []);
            router.push("/reportes/listado");
          } else {
            store.state.toast.add({
              severity: "error",
              summary: "",
              detail: response.message,
              life: 5000,
            });
          }
        };

        if (count === length) finish();

        report.selectedDocuments.forEach(async (doc) => {
          const name = doc.name;
          const key = `${responsePath.path}${name}`;
          const uploaded = async () => {
            documents.push({
              path: responsePath.path,
              name: name
                .split(".")
                .slice(0, -1)
                .join("."),
              ext: validation.extensionRegex.exec(name)[0],
            });

            count += 1;
            if (count === length) finish();
          };
          aws.uploadFile(key, doc, uploaded);
        });
      } else {
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: responsePath.message,
          life: 5000,
        });
      }
    };

    onBeforeMount(async () => {
      if (!store.state.openMode) router.push("/reportes/listado");
      store.commit("addBreadcrumb", { label: route.name, to: route.path });
      store.commit("setLoading", true);
      await store.dispatch(
        actions.reportActions.findAll,
        store.state.general.selectedBuilding
      );
      store.commit("setLoading", false);
    });

    onBeforeUnmount(() => {
      store.commit("removeBreadcrumb");
    });

    watchEffect(() => {
      if (report.data.title) report.rules.title = false;
      if (report.data.date) report.rules.date = false;
      if (report.data.description) report.rules.description = false;
    });

    return { store, report, onSave, onSelectFiles };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
}
.link-label {
  margin-right: 1rem;
  font-family: "klavika";
  color: var(--primary);
}
</style>
